import React from 'react';
import MultiDatasetMatchEventListItem from '../list/MultiDatasetMatchEventListItem';

/**
 * MultiDatasetMatchEvent - Renders an individual multi-dataset match event
 */
function MultiDatasetMatchEvent({
  match,
  onEventClick,
  onDeleteClick,
  disabled
}) {
  return (
    <MultiDatasetMatchEventListItem
      event={match}
      onClick={onEventClick}
      onDelete={onDeleteClick}
      disabled={disabled}
    />
  );
}

export default React.memo(MultiDatasetMatchEvent);
